import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { SelectOfferFibercoPage } from "@nju/feature-portal-offers";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function SelectFibercoOffer() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="default" spacing="xl">
        <ClientSideOnly>
          <SelectOfferFibercoPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
